import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import useUserPlatform from '@/hooks/use-user-platform';
import type { ResponseError } from '@/models/response';
import ROUTES from '@/routes';
import type { SearchUserData, SearchUserResponse } from '@/routes/contact/request';
import { useUserId } from '@/stores/auth';
import { addTranslateToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useSearchUserByPhoneAndId() {
  const navigate = useNavigate();
  const { isDesktop, isEmbedded } = useUserPlatform();
  const userId = useUserId();

  return useMutation<SearchUserData | null, ResponseError, string>({
    mutationKey: ['/SearchUserByPhoneAndID'],
    mutationFn: async (params) => {
      const response = await fetcher<SearchUserResponse>(
        '/SearchUserByPhoneAndID',
        { keyword: params },
        { validResponseCodes: [0, 1] },
      );

      if (response.Code !== 0 || !response.Data?.[0]) return null;

      return response.Data[0];
    },
    onSuccess: (data) => {
      if (data) {
        if (data.UID === userId) {
          if (isEmbedded || isDesktop) {
            addTranslateToast({
              type: 'info',
              message: 'contact.contact-myself',
            });
          } else {
            navigate(ROUTES.MY.INFO.$path(), { replace: true });
          }
        } else {
          navigate(
            ROUTES.CONTACT.REQUEST.USER.$buildPath({
              searchParams: {
                id: data.UID,
                key: data.VChatID as string,
                source: 'search',
              },
            }),
            { replace: true },
          );
        }
      }
    },
  });
}
